export enum PayinOrderTimeoutConfigKey {
  New = 'new',
  Requisites = 'requisites',
  Payment = 'payment',
}
